import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getKPIDefinitionAction } from "../actions";
import { getRows, getLoading, getDateFormat } from "../selectors";
import { CLEAR_STATE } from "../actionTypes";
import { getIsExportingGrid } from "@icarius-app/selectors";
import { getLocalizedString } from "@icarius-localization/strings";
import CommonPage from "@icarius-common/commonPage";
import paths from "@icarius-router/paths";
import FormContainer from "./form/formContainer";
import ConfirmationDialog from "./dialogs/confirmationDialog";
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";
import useABM from "./useABM";
import DuplicateDialog from "./dialogs/duplicateDialog";
import { FiltersDialog } from "@icarius-common/filtersDialog";
import { getFiltersIsLoading } from "@icarius-common/filtersDialog/selectors";
import MenuItemWithIcon from "@icarius-common/MenuItemWithIcon";
import SearchConcept from "./searchConcept";

const KPIdefinition = ({ history }) => {
    const dispatch = useDispatch();

    const data = useSelector(getRows);
    const dateFormat = useSelector(getDateFormat);
    const isLoading = useSelector(getLoading);
    const isExportinGrid = useSelector(getIsExportingGrid);
    const filtersIsLoading = useSelector(getFiltersIsLoading);

    useEffect(() => {
        dispatch(getKPIDefinitionAction());
        return () => {
            dispatch({ type: CLEAR_STATE });
        };
    }, [dispatch]);

    const {
        filtersDialogIsOpen,
        deleteDialogIsOpen,
        createEditDialogIsOpen,
        duplicateDialogIsOpen,
        selectedItem,
        handleOpenFilterDialog,
        handleCloseFilterDialog,
        handleOpenCreateDialog,
        handleOpenEditDialog,
        handleCloseEditDialog,
        handleOpenDeleteDialog,
        handleCloseDeleteDialog,
        handleOpenDuplicateDialog,
        handleCloseDuplicateDialog,
        handleDelete,
        handleDuplicate,
    } = useABM();

    const helpItems = [
        <MenuItemWithIcon
            key={"a"}
            value={"/resources/ICARIUS - Iconografia KPI - Iconos.pdf"}
            text={getLocalizedString("kpiIconographyIcons")}
            type={"file"}
        />,
        <MenuItemWithIcon
            key={"b"}
            value={"/resources/ICARIUS - Definición de gestión (Consultas-GeoAnálisis-KPI).pdf"}
            text={getLocalizedString("managementDefinitionConsultationsGeoAnalysisKPI")}
            type={"file"}
        />,
    ];

    const handleGoBack = () => {
        history.push(paths.managementDefinition);
    };

    const goBackItem = () => (
        <CustomIconButton title={getLocalizedString("goBack")} onClick={handleGoBack} type={"goBack"} />
    );

    const filterItem = (gridRef) => (
        <CustomIconButton
            title={getLocalizedString("filter")}
            onClick={() => handleOpenFilterDialog(gridRef)}
            type={"filter"}
        />
    );

    const addItem = () => (
        <CustomIconButton title={getLocalizedString("create")} onClick={() => handleOpenCreateDialog()} type={"add"} />
    );

    const deleteItem = (gridRef) => (
        <CustomIconButton
            title={getLocalizedString("delete")}
            onClick={() => handleOpenDeleteDialog(gridRef)}
            type={"delete"}
        />
    );

    const editItem = (gridRef) => (
        <CustomIconButton
            title={getLocalizedString("edit")}
            onClick={() => handleOpenEditDialog(gridRef)}
            type={"edit"}
        />
    );

    const duplicateItem = (gridRef) => (
        <CustomIconButton
            title={getLocalizedString("duplicate")}
            onClick={() => handleOpenDuplicateDialog(gridRef)}
            type={"duplicate"}
        />
    );

    const isLoadingAnything = isExportinGrid || isLoading || filtersIsLoading;

    const searchItem = (ref) => <SearchConcept gridRef={ref} data={data} />;

    return (
        <>
            {createEditDialogIsOpen ? (
                <FormContainer isLoading={isLoading} data={selectedItem} handleClose={handleCloseEditDialog} />
            ) : (
                <CommonPage
                    key={data}
                    columnDefPage={paths.kpiDefinition}
                    title={getLocalizedString("kpiDefinition")}
                    gridTitle={getLocalizedString("kpiDefinition")}
                    menuItems={[goBackItem, searchItem, addItem, editItem, deleteItem, duplicateItem, filterItem]}
                    helpItems={helpItems}
                    rowData={data}
                    dateFormat={dateFormat}
                    isLoading={isLoadingAnything}
                    hasExpand
                    hasHelp
                >
                    {deleteDialogIsOpen && !isLoadingAnything && (
                        <ConfirmationDialog
                            open={deleteDialogIsOpen}
                            title={getLocalizedString("atention")}
                            text={getLocalizedString("areYouSureYouWantToDeleteKPIDefinition")}
                            handleConfirm={handleDelete}
                            handleClose={handleCloseDeleteDialog}
                        />
                    )}
                    {filtersDialogIsOpen && !isLoadingAnything && (
                        <FiltersDialog
                            open={filtersDialogIsOpen}
                            type={"KPI"}
                            code={selectedItem.code}
                            data={selectedItem.filterData}
                            handleFetchUpdatedData={() => dispatch(getKPIDefinitionAction())}
                            handleClose={handleCloseFilterDialog}
                        />
                    )}
                    {duplicateDialogIsOpen && !isLoadingAnything && (
                        <DuplicateDialog
                            open={duplicateDialogIsOpen}
                            data={selectedItem}
                            handleConfirm={handleDuplicate}
                            handleClose={handleCloseDuplicateDialog}
                        />
                    )}
                </CommonPage>
            )}
        </>
    );
};

export default KPIdefinition;
